import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaSignInAlt, FaUserPlus } from 'react-icons/fa';

function ProductAuthRequiredDrawer({ isOpen, onClose, product }) {
  const location = useLocation();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const mutedColor = useColorModeValue('gray.600', 'gray.400');
  const panelBg = useColorModeValue('gray.50', 'gray.700');

  const redirectPath = `${location.pathname}${location.search}`;
  const loginUrl = `/login?redirect=${encodeURIComponent(redirectPath)}`;

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="md" placement="right">
      <DrawerOverlay />
      <DrawerContent bg={bgColor}>
        <DrawerCloseButton />
        <DrawerHeader borderBottom="1px" borderColor={borderColor}>
          <Heading size="md">Accedi per acquistare</Heading>
          {product?.nome && (
            <Text fontSize="sm" color={mutedColor} fontWeight="normal" mt={1}>
              {product.nome}
            </Text>
          )}
        </DrawerHeader>

        <DrawerBody>
          <VStack align="stretch" spacing={5} py={2}>
            <Box
              p={4}
              borderRadius="md"
              border="1px solid"
              borderColor={borderColor}
              bg={panelBg}
            >
              <Text color={mutedColor} lineHeight="tall">
                Per procedere con l&apos;acquisto merch devi essere loggato. Se
                non sei ancora socio CIL, tesserati per accedere al catalogo e
                completare l&apos;ordine.
              </Text>
            </Box>
          </VStack>
        </DrawerBody>

        <DrawerFooter borderTop="1px" borderColor={borderColor} gap={3}>
          <Button variant="outline" onClick={onClose} flex={1}>
            Chiudi
          </Button>
          <Button
            as={RouterLink}
            to={loginUrl}
            colorScheme="teal"
            leftIcon={<Icon as={FaSignInAlt} />}
            flex={1}
            onClick={onClose}
          >
            Accedi
          </Button>
          <Button
            as={RouterLink}
            to="/tesseramento"
            colorScheme="purple"
            variant="outline"
            leftIcon={<Icon as={FaUserPlus} />}
            flex={1}
            onClick={onClose}
          >
            Tesserati
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}

export default ProductAuthRequiredDrawer;
